import { useState } from "react";
import { Alert, Button, CircularProgress, Menu, MenuItem, ListItemText } from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function PvExportMenu({ items, busy, error }) {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        startIcon={busy ? <CircularProgress size={16} /> : <DownloadOutlinedIcon fontSize="small" />}
        endIcon={<ArrowDropDownIcon fontSize="small" />}
        sx={{ textTransform: "none", fontWeight: 700 }}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {items.map((item) => (
          <MenuItem
            key={item.label}
            disabled={item.disabled}
            onClick={() => {
              setAnchorEl(null);
              item.onClick();
            }}
          >
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
      {error && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      )}
    </>
  );
}
